import { FormProps } from '@alphabait/ui/form'
import { RadioGroupTypeInput } from './custom-types'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useController } from 'react-hook-form'
import styles from './form.module.css'

export default function RadioGroupType({
  field,
  formProps,
}: {
  field: RadioGroupTypeInput
  formProps: FormProps
}) {
  const { id } = useParams()
  const { t } = useTranslation()

  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    control: formProps.control,
    name: field.name,
  })

  return (
    <div>
      <div className="grid grid-cols-2 gap-4 my-2">
      <label
        htmlFor={`${field.name}-offline`}
        className={cx(
          'flex cursor-pointer rounded-lg border border-border bg-white p-2 shadow-sm focus:outline-none hover:border-secondary',
          `${value === 'offline' && 'border-primary'}`,
          `${id && value === 'online' ? 'pointer-events-none opacity-50' : ''}`,
        )}
      >
        <input
          type="radio"
          name={field.name}
          value="offline"
          checked={value === 'offline'}
          onChange={(e) => {
            onChange(e.target.value)
          }}
          className="sr-only"
          id={`${field.name}-offline`}
          data-testid={`${field.uiOptions?.testId}-offline`}
          disabled={id ? true : false}
        />
        <span className="flex flex-col text-md">
          <span className="font-bold">{t('campaign_details.offline')}</span>
          <span className="font-medium">
            {t('campaign_details.offline_description')}
          </span>
        </span>
      </label>
      <label
        htmlFor={`${field.name}-online`}
        className={cx(
          'flex cursor-pointer rounded-lg border border-border bg-white p-2 shadow-sm focus:outline-none hover:border-secondary',
          `${value === 'online' && 'border-primary'}`,
          `${
            id && value === 'offline' ? 'pointer-events-none  opacity-50' : ''
          }`,
        )}
      >
        <input
          type="radio"
          name={field.name}
          value="online"
          checked={value === 'online'}
          onChange={(e) => {
            onChange(e.target.value)
          }}
          className="sr-only"
          id={`${field.name}-online`}
          data-testid={`${field.uiOptions?.testId}-online`}
          disabled={id ? true : false}
        />
        <span className="flex flex-col text-md">
          <span className="font-bold">{t('campaign_details.online')}</span>
          <span className="font-medium">
            {t('campaign_details.online_description')}
          </span>
        </span>
      </label>
      </div>
      {error && (
        <span
          className={styles.errorMessage}
          data-testid={`${field.name}-error`}
        >
          {t(`validation_messages.${error.message}`)}
        </span>
      )}
    </div>
  )
}
